import React from 'react';
import {Container} from '@material-ui/core';
import {FirebaseContext} from '../../Firebase';
import {Button, TextField} from '@material-ui/core';
import ReactGoogleSlides from 'react-google-slides';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';

const Session9 = () => {
  const firebase = React.useContext(FirebaseContext);
  const group = firebase.userData.group;
  const [scr, setScr] = React.useState(0);
  const [CR, setCR] = React.useState(false);
  const [response, setResponse] = React.useState('');
  const [respTitre, setRespTitre] = React.useState('');
  const [respHistoire, setRespHistoire] = React.useState('');

  return (
    <div>
      <Container
        style={{
          backgroundColor: 'lightblue',
          padding: '10px',
          minHeight: '270px',
        }}
      >
        {/* SCREENS INTRO ALL GROUP*/}
        {scr === 0 && (
          <div>
            <h3>Bienvenue dans cette nouvelle session !</h3>
            <p>
              Tu passes une grande partie de ton temps, de ta vie, en classe
              avec tes camarades ou dans des activités extra-scolaires. Et si
              nous allions voir comment l’entraide est possible dans ce cas ?
            </p>
            <p>
              Clique sur le bouton continuer une fois que tu as bien compris
              pour continuer.
            </p>
          </div>
        )}
        {scr === 1 && (
          <div style={{textAlign: 'center', width: '100%'}}>
            <ReactGoogleSlides
              width={'100%'}
              height={480}
              slidesLink="https://docs.google.com/presentation/d/1oUqqoLnfFsp_nVYrmG0hvXk9oNSzOmFDRu0gbBZOQ-Y"
              position={0}
              showControls
            />
            <br />
            <FormControl component="fieldset">
              <FormLabel component="legend">
                Les camarades dans la vidéo ont lancé une association pour que
                tout le monde puisse avoir :
              </FormLabel>
              <RadioGroup
                aria-label="team"
                defaultValue=""
                name="radio-buttons-group-team"
                onChange={(e) => {
                  setCR(true);
                  setResponse(e.target.value);
                }}
              >
                <FormControlLabel
                  value="repas_cantine"
                  control={<Radio />}
                  label="Un repas à la cantine"
                />
                <FormControlLabel
                  value="fournitures_scolaires"
                  control={<Radio />}
                  label="Des fournitures scolaires"
                />
                <FormControlLabel
                  value="sac_piscine"
                  control={<Radio />}
                  label="Un sac de piscine"
                />
              </RadioGroup>
            </FormControl>
          </div>
        )}
        {/* SCREENS CONTROL*/}
        {group.toString() === 'control' && scr === 2 && (
          <div>
            <p>
              Dans ton école, tu as peut-être des classes d’enfants plus petits.
            </p>
            <p>
              Ta mission pour cette séance, et les séances prochaines, sera
              d’organiser un spectacle pour une classe d’enfants de CP.
            </p>
          </div>
        )}
        {group.toString() === 'control' && scr === 3 && (
          <div>
            <p>
              Pour commencer, il faut que tu décides du thème de ton spectacle !
              Prends ton temps, et une fois que tu as trouvé, tu peux écrire le
              titre de ton spectacle ci-dessous.
            </p>
            <TextField
              fullWidth
              rows="4"
              id="titre"
              label="Titre de ton spectacle"
              variant="outlined"
              value={respTitre}
              onChange={(e) => {
                setRespTitre(e.target.value);
              }}
            />
            <p>
              Maintenant, il faut que tu décides l’histoire de ton spectacle. En
              quelques lignes, raconte cette histoire ci-dessous.
            </p>
            <TextField
              multiline
              fullWidth
              rows="4"
              id="titre"
              label="Titre de ton spectacle"
              variant="outlined"
              value={respHistoire}
              onChange={(e) => {
                setRespHistoire(e.target.value);
              }}
            />
            <p>Quand tu as terminé, clique sur le bouton ci-dessous.</p>
          </div>
        )}
        {group.toString() === 'control' && scr === 4 && (
          <div>
            <p>
              Nous avons terminé pour aujourd’hui. Rendez-vous à la prochaine
              session pour continuer l’organisation de ce spectacle. N’oublie
              pas de te connecter dans quelques jours pour la prochaine séance !
            </p>
            <p>Merci pour ta participation !</p>
            <p>Clique sur le bouton ci-dessous pour quitter la séance.</p>
          </div>
        )}
        {/* SCREENS TEST*/}
        {(group.toString() === 'test_a' ||
          group.toString() === 'test_b' ||
          group.toString() === 'test_c') &&
          scr === 2 && (
            <div>
              <p>
                Dans ton école, tu as peut-être des classes d’enfants plus
                petits.
              </p>
              <p>
                Ta mission pour cette séance, sera d’expliquer ton action
                bénévole à une classe de CP dans un texte écrit.
              </p>
              <p>Continuons !</p>
            </div>
          )}
        {(group.toString() === 'test_a' ||
          group.toString() === 'test_b' ||
          group.toString() === 'test_c') &&
          scr === 3 && (
            <div>
              {group.toString() === 'test_a' && (
                <p>
                  Pour commencer, il faut que tu décides du titre de ta
                  présentation liée à l’écologie. Prends ton temps, et une fois
                  que tu as trouvé, tu peux écrire le titre ci-dessous.
                </p>
              )}
              {group.toString() === 'test_b' && (
                <p>
                  Pour commencer, il faut que tu décides du titre de ta
                  présentation liée au soutien aux personnes hospitalisées.
                  Prends ton temps, et une fois que tu as trouvé, tu peux écrire
                  le titre ci-dessous.
                </p>
              )}
              {group.toString() === 'test_c' && (
                <p>
                  Pour commencer, il faut que tu décides du titre de ta
                  présentation liée au soutien aux personnes en situation de
                  pauvreté. Prends ton temps, et une fois que tu as trouvé, tu
                  peux écrire le titre ci-dessous.
                </p>
              )}

              <TextField
                fullWidth
                rows="4"
                label="Titre de ton spectacle"
                variant="outlined"
                value={respTitre}
                onChange={(e) => {
                  setRespTitre(e.target.value);
                }}
              />
              {group.toString() === 'test_a' && (
                <p>
                  Maintenant, que veux-tu leur dire sur la cause de l’écologie ?
                  Veille bien à utiliser des mots que des enfants en classe de
                  CP pourront comprendre facilement.
                </p>
              )}
              {group.toString() === 'test_b' && (
                <p>
                  Maintenant, que veux-tu leur dire sur le soutien aux personnes
                  hospitalisées ? Veille bien à utiliser des mots que des
                  enfants en classe de CP pourront comprendre facilement.
                </p>
              )}
              {group.toString() === 'test_c' && (
                <p>
                  Maintenant, que veux-tu leur dire sur la précarité et la
                  pauvreté ? Veille bien à utiliser des mots que des enfants en
                  classe de CP pourront comprendre facilement.
                </p>
              )}
              <TextField
                multiline
                fullWidth
                rows="4"
                label="Titre de ton spectacle"
                variant="outlined"
                value={respHistoire}
                onChange={(e) => {
                  setRespHistoire(e.target.value);
                }}
              />
              <p>Quand tu as terminé, clique sur le bouton ci-dessous.</p>
            </div>
          )}
        {(group.toString() === 'test_a' ||
          group.toString() === 'test_b' ||
          group.toString() === 'test_c') &&
          scr === 4 && (
            <div>
              <p>
                Nous avons terminé pour aujourd’hui. Lors de la prochaine
                session, les élèves de la classe de CP te poseront des questions
                auxquelles tu pourras répondre. N’oublie pas de te connecter
                dans quelques jours pour la prochaine séance !
              </p>
              <p>Merci pour ta participation !</p>
              <p>Clique sur le bouton ci-dessous pour quitter la séance.</p>
            </div>
          )}
      </Container>
      {/* BUTTON*/}
      <Button
        style={{display: 'block', margin: 'auto'}}
        disabled={scr === 1 && !CR}
        variant="contained"
        color="primary"
        onClick={() => {
          if (scr === 3) {
            // save TEST DATA
            let now = new Date();
            firebase
              .databehav(firebase.userData.pseudo)
              .collection('session9')
              .add({
                date: now,
                response: response,
                respTitre: respTitre,
                respHistoire: respHistoire,
              })
              .catch((error) => {
                console.log(error);
              });
          }
          if (scr === 4) {
            firebase.signoutUser();
          } else {
            setScr(scr + 1);
          }
        }}
      >
        Continuer
      </Button>
    </div>
  );
};
export default Session9;
